import {BasePqmFieldValue} from "./BasePqmFieldValue";
import {PqmFieldRegister} from "./PqmFieldRegister";
import {createHtmlElement, escapeHtml, getSelectedValue, setSelectedValue} from "../../Utils";
import {PqmPacket, PqmProcData} from "../pqmTypes";
import {UiRadioList} from "../../components/UiRadioList";
import {TreeSelector} from "../../TreeSelector";
import {UiTomSelect} from "../../components/UiTomSelect";
import {MuNamedWidgets} from "mu-widget/lib/MuWidget";

export class PqmFieldOrgDivision extends BasePqmFieldValue {
	static getValueTypes(): string[] {
		return [ "orgDivision:*" ];
	}

	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		value: TreeSelector,
	}>;

	beforeIndex() {
		// @ts-ignore
		this.container.append(
			createHtmlElement('div', {
				mu: "value:TreeSelector#value",
				'mu-params': JSON.stringify({
					inModal: true,
				})
			})
		);
	}

	async afterIndex() {
		this.muNamedWidget.value.bindTree(
			await this.getPropertyInAncestors('cpOrgDivision').fetch()
		);
	}

	setDisabled(disabled: boolean) {
		this.muNamedWidget.value.setDisabled(disabled);
	}
}

// @ts-ignore
PqmFieldRegister.register(PqmFieldOrgDivision);